import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/alert-button/alert-button.js';
      import {AlertType} from '@oicl/openbridge-webcomponents/dist/types.js';
import {ObcAlertButtonType} from '@oicl/openbridge-webcomponents/dist/components/alert-button/alert-button.js';

      export interface Props {
     nAlerts?: number;
     alertType?: AlertType | undefined;
     type?: ObcAlertButtonType;
     large?: boolean;
     showSilenceButton?: boolean;
     silenceButtonDisabled?: boolean;
     counter?: boolean;
     blinking?: boolean;
     flatMaxBreakpointPx?: number;
     silenceButtonMinBreakpointPx?: number
   }

      
  
      export type {AlertType} from '@oicl/openbridge-webcomponents/dist/types.js';
export type {ObcAlertButtonType} from '@oicl/openbridge-webcomponents/dist/components/alert-button/alert-button.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcAlertButton',
  props: {
    nAlerts: {},
    alertType: {},
    type: {},
    large: { type: Boolean },
    showSilenceButton: { type: Boolean },
    silenceButtonDisabled: { type: Boolean },
    counter: { type: Boolean },
    blinking: { type: Boolean },
    flatMaxBreakpointPx: {},
    silenceButtonMinBreakpointPx: {}
  },
  emits: ["click-alert", "click-silence"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onClickAlert: (event: CustomEvent<void>) => emit('click-alert', event as CustomEvent<void>),
onClickSilence: (event: CustomEvent<void>) => emit('click-silence', event as CustomEvent<void>)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-alert-button',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})